import { useEffect, useState } from "react";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";

export function BtcTicker({ compact = false }: { compact?: boolean }) {
  const [price, setPrice] = useState(67432.18);
  const [prev, setPrev] = useState(67432.18);

  useEffect(() => {
    let t = 0;
    const id = setInterval(() => {
      t += 1;
      const base = 67000 + Math.sin(t / 12) * 1500 + Math.sin(t / 3) * 250;
      const noise = (Math.random() - 0.5) * 180;
      setPrev((p) => price ?? p);
      setPrice(Math.round((base + noise) * 100) / 100);
    }, 2000);
    return () => clearInterval(id);
  }, [price]);

  const up = price >= prev;
  const delta = price - prev;

  if (compact) {
    return (
      <span className="inline-flex items-center gap-2 font-mono text-sm">
        <span className="text-muted-foreground">BTC</span>
        <span>${price.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
        <span className={up ? "text-emerald-400" : "text-red-400"}>{up ? "▲" : "▼"}</span>
      </span>
    );
  }

  return (
    <div className="glass rounded-2xl px-5 py-4 flex items-center gap-4">
      <div className="grid place-items-center h-10 w-10 rounded-full bg-primary/15 text-primary">
        ₿
      </div>
      <div className="flex-1">
        <div className="text-[11px] uppercase tracking-widest text-muted-foreground">BTC / USD · Live (simulated)</div>
        <div className="font-mono text-2xl font-semibold">
          ${price.toLocaleString("en-US", { minimumFractionDigits: 2 })}
        </div>
      </div>
      <div className={`flex items-center gap-1 text-sm font-mono ${up ? "text-emerald-400" : "text-red-400"}`}>
        {up ? <ArrowUpRight className="h-4 w-4" /> : <ArrowDownRight className="h-4 w-4" />}
        {delta >= 0 ? "+" : ""}{delta.toFixed(2)}
      </div>
    </div>
  );
}